module.exports = __webpack_public_path__ + "static/kartchen2-392b7a72659dd8b46b50c50c8d6eea9e.png";